import { NATIONAL_TEAMS } from '../data/nationalTeams';

const normalize = (value) => {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z\s-]/g, '')
    .replace(/[-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};

const stripAgeSuffix = (value) => {
  return value.replace(/\s*(u\s?-?\d{2}|under\s*\d{2})$/i, '').trim();
};

const NATIONAL_TEAM_SET = new Set(NATIONAL_TEAMS.map(normalize));
const INTERNATIONAL_LEAGUE_COUNTRIES = new Set(
  [
    'World',
    'Europe',
    'Africa',
    'Asia',
    'South America',
    'North America',
    'Central America',
    'North & Central America',
    'Oceania',
    'International'
  ].map(normalize)
);

const INTERNATIONAL_LEAGUE_KEYWORDS = [
  'world',
  'international',
  'friendly',
  'friendlies',
  'nation',
  'nations league',
  'euro',
  'copa',
  'conmebol',
  'fifa',
  'afcon',
  'asian cup',
  'gold cup',
  'olympic',
  'youth',
  'qualif',
  'qualification'
];

const YOUTH_LEAGUE_PATTERN = /\bu\s*-?\s*\d{2}\b/;
const UNDER_AGE_PATTERN = /under\s*\d{2}\b/;

export const isNationalTeamName = (teamName) => {
  if (!teamName) return false;
  const normalized = normalize(stripAgeSuffix(teamName));
  return NATIONAL_TEAM_SET.has(normalized);
};

const isInternationalLeagueCountry = (country) => {
  if (!country) return false;
  return INTERNATIONAL_LEAGUE_COUNTRIES.has(normalize(country));
};

const isInternationalLeagueName = (name) => {
  if (!name) return false;
  const normalized = name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/[-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  if (YOUTH_LEAGUE_PATTERN.test(normalized)) return true;
  if (UNDER_AGE_PATTERN.test(normalized)) return true;
  return INTERNATIONAL_LEAGUE_KEYWORDS.some((keyword) =>
    normalized.includes(keyword)
  );
};

export const isNationalTeamStat = (stat) => {
  if (!stat) return false;
  const nationalFlag = stat?.team?.national;
  if (nationalFlag === true) return true;
  if (nationalFlag === false) return false;

  if (!isNationalTeamName(stat?.team?.name)) return false;
  if (isInternationalLeagueCountry(stat?.league?.country)) return true;
  if (!stat?.league?.country && isInternationalLeagueName(stat?.league?.name)) {
    return true;
  }
  return false;
};
